import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import "../styles/user-profile.scss";
import Avatar from '@mui/material/Avatar';
import { Button } from '@mui/material';

export const UserData = (props) => {

    const {data} = props;

    const statuses = ["Новый", "На модерации", "Прошел модерацию", "Ожидается оплата",
        "Активный", "Отклонен", "Подписка истекла", "Ожидается первая оплата", "Заблокирован"];

    let userStatus = statuses[data.status];
    if (data.status === 4){
        userStatus = "Подписка действительна до " + new Date(data.subscriptionEndData).toLocaleDateString();
    }
    else if (data.status === 6){
        userStatus = "Подписка истекла " + new Date(data.subscriptionEndData).toLocaleDateString();
    }

    return (
        <div>
            <div className="user-profile-head">
                <Avatar sx={{ width: 120, height: 120, mr: 2, display: "inline-flex" }}>{data.fullName?.substring(0, 1)}</Avatar>             
                <h3>{data.fullName}</h3>
                <p>{userStatus}</p>
                {(data.status === 4 || data.status === 6 || data.status === 2 || data.status === 3 || data.status === 7) && 
                    <Button variant="contained" onClick={() => window.location.href = '/payment'}>Оплатить подписку</Button>
                }
            </div>
            <div className="contact-info">
                <h4 className="contact-info-head">Контактные данные</h4>
                <div className="contact-info-lines">
                    <div className="contact-info-line">
                        <PhoneIcon />
                        <p className="contact">{data.phoneNumber}</p>
                    </div>
                    <div className="contact-info-line">
                        <MailOutlineIcon />
                        <p className="contact">{data.email}</p>
                    </div>
                </div>
            </div>
        </div>
    )

}